import { TripAnalytics } from "./trips"
import { getSpeedingPercentage } from "./utils"

export type MockAnalytics = Partial<TripAnalytics>

export const generateAnalytics = (mockAnalytics?: MockAnalytics): TripAnalytics => {
  const speedBands = mockAnalytics?.speedBands ?? null
  return {
    ...mockAnalytics,
    averageSpeedExceedencePercentage: mockAnalytics?.averageSpeedExceedencePercentage ?? null,
    distance: mockAnalytics?.distance ?? 0.3,
    distanceSpentSpeeding: getSpeedingPercentage(speedBands),
    safeMiles: mockAnalytics?.safeMiles ?? null,
    score: mockAnalytics?.score ?? null,
    speedBands,
    unsafeMiles: mockAnalytics?.unsafeMiles ?? null,
  }
}
